import {Component, OnInit} from '@angular/core';
import {ThemeService} from '@services/core/theme/theme.service';
import {LocalizeTextPipe} from '@shared/pipes/localize-text/localize-text.pipe';
import { TitleCasePipe } from '@angular/common';
import {GlobalSearchBarComponent} from '../../../components/global-search-bar/global-search-bar.component';
import {LoginSubjBubbleComponent} from "@app/areas/users/components/login-subj-bubble/login-subj-bubble.component";
import {RegionSelectionComponent} from "@app/areas/users/components/region-selection/region-selection.component";
import {AppAuthService} from "@services/core/auth/app-auth.service";
import {RegionService} from "@app/areas/auth/services/region.service";
import {SupportedRegion} from "@app/areas/auth/models/supported-region.interface";
import {IdentityUserRegion} from "@app/areas/users/models/identity-user.interface";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [GlobalSearchBarComponent, TitleCasePipe, LocalizeTextPipe, LoginSubjBubbleComponent, RegionSelectionComponent]
})
export class HeaderComponent implements OnInit {
  defaultRegion!: IdentityUserRegion

  constructor(public theme: ThemeService, public auth: AppAuthService, private r: RegionService) {
    this.defaultRegion = this.r.selectedRegion$() ?? this.auth.user$().identityProfile.region;
  }

  ngOnInit(): void {
  }

  handleRegionChange(value: SupportedRegion): void {
    this.r.selectRegion(value.id)
    this.auth.refreshUserPractitionerData()
  }
}
